<my-content placeholder="navigation">


    <div class="col-sm-12 divbordergry "></div>
    
    <div class=" col-sm-12">
        <div class="titlebar d-flex align-items-center justify-content-between my-2">
            <div class="titlebar-text">
                <span class="ml-2 page-title">Manage System Configuration</span>
            </div>
        <div class="tools d-flex align-items-center gap-3">
            <div
              *ngFor="let master of masters; let i = index"
              [class.active]="i === activeBG"
              class="point tablinks "
            >
              <a class="tab_border" (click)="OpenPage(master.Link, i)">
                 {{ master.SubDescr }}
              </a>
            </div>
          </div>
        </div>
        <div class="col-sm-12" [hidden]="HideMasterDetails">
            <iframe width="100%" Height="700 px" [src]="modalURL|safe"></iframe>
        </div>
    </div>

</my-content>

